import axios from "axios";

export const client = async (endpoint, request, returnFullResponse = false) => {
    try {
      // Configure axios api
      const axiosConfig = axios.create({
        baseURL: `${process.env.NETLIFY_URL}/.netlify/functions/`,
        headers: {
          'Content-Type': 'application/json'
        }
        // timeout: 1000,
      });

      const response = await axiosConfig({
        url: endpoint,
        method: 'post',
        data: request,
      });

      // return full response along with data
      if(returnFullResponse) {
        return response ? response : {};
      }

      // return only data
      return response?.data ? response.data : {};
      
    } catch (error) {
      console.error(`Error fetching data for endpoint ${endpoint}`, error);
      return {};
    }
  };
  
